<template>
  <div>
    <template v-if="config.global.homeSliderFull">
      <Slider maxHeight="100vh" />
    </template>
    <template v-if="!config.global.homeSliderFull">
      <Slider />
    </template>
    <div class="wrap">
      <Level4Search />
      <Locations />
    </div>
  </div>
</template>

<script>
import Level4Search from '@/modules/level4/components/Level4Search.vue';
import { Slider, config } from '@/modules/core';
import Locations from '../components/Locations.vue';

export default {
  name: 'Home',
  mixins: [config],
  components: {
    Slider,
    Level4Search,
    Locations,
  },
};
</script>
